import { useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'
import { RewardTimeFrameType } from 'graphql/generated/scheme'
import { MemberOfferRewardWithUserOfferType } from 'pages/offers/type'
import { Button } from 'components/atoms/button'

interface OfferSuccessModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	offer: MemberOfferRewardWithUserOfferType | null
	onClose?: () => void
}

export default function OfferSuccessModal({ open, setOpen, offer, onClose }: OfferSuccessModalProps) {
	const isDrawOffer = offer?.timeFrameConstraint?.timeFrameType === RewardTimeFrameType.Draw
	const coverImage = offer?.coverUrl
	const offerName = offer?.name

	return (
		<ContentModal
			open={open}
			setOpen={setOpen}
			isModal
			hideCloseButton
			title={isDrawOffer ? "You've Entered the Draw!" : 'Your offer is ready to claim!'}
		>
			<div className="relative flex flex-col items-center gap-8">
				<div className="max-w-[304px]">
					<div className="flex flex-col items-center gap-8">
						{coverImage && (
							<div className="w-[200px] h-auto rounded-xl overflow-hidden flex-shrink-0">
								<img
									src={`${import.meta.env.VITE_MEDIA_URL}/${coverImage}`}
									alt={offerName}
									className="w-full h-auto"
								/>
							</div>
						)}
						{isDrawOffer ? (
							<p className="text-secondary-text text-sm text-center">
								Winners will be selected shortly to determine if you've won the raffle.
							</p>
						) : (
							<div className="flex flex-col items-center gap-2">
								<p className="text-white text-base font-semibold text-center">
									You have redeemed your offer
								</p>
								<p className="text-secondary-text text-sm text-center">
									You can find instructions for how to redeem your offer within the offer page.
								</p>
							</div>
						)}
					</div>
				</div>
				<Button
					variant="secondary"
					fullWidth
					onClick={() => {
						setOpen(false)
						onClose?.()
					}}
				>
					Close
				</Button>
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface OfferSuccessModalManagedProps {
	offer: MemberOfferRewardWithUserOfferType | null
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'offer-success': OfferSuccessModalManagedProps
	}
}

export function ManagedOfferSuccessModal({
	onClose,
	...rest
}: OfferSuccessModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<OfferSuccessModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onClose={handleClose}
			{...rest}
		/>
	)
}
